import { useState } from "react";
import { useQuery } from "@apollo/client";

import { Picks, UseTalentPicksProps } from "../types";
import ApolloOptions from "../graphql/options.graph";
import { GET_GRAPH_TALENT_PICKS } from "../graphql/queries/talentPicksQuery";
import useTalentPicksSubscription from "./useTalentPicksSubscription";

const useTalentPicks = (props: UseTalentPicksProps) => {
  const [picksData, setPicksData] = useState<Picks>({
    talentPicks: [],
    talentsList: []
  });

  const { loading, subscribeToMore } = useQuery(GET_GRAPH_TALENT_PICKS, {
    ...ApolloOptions.options(props),
    onCompleted: (data) => {
      const newPicks: Picks = ApolloOptions.getProps(data);
      setPicksData(newPicks);
    }
  });

  useTalentPicksSubscription(subscribeToMore);

  return {
    loading,
    talentPicks: picksData
  };
};

export default useTalentPicks;
